module.exports = __webpack_public_path__ + "img/27c625acc36764b450992570d402d003.svg";